import type {PropsWithChildren} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import {jsLatestPressReleases} from '../lib/const';
import styles from './root.module.css';

type Props = PropsWithChildren;

export function LatestPressReleasesRoot({children}: Props) {
  return (
    <div
      className={clsx(
        styles.root,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
      id={jsLatestPressReleases}
    >
      {children}
    </div>
  );
}
